import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/auth/auth.service';
import { Duyuru } from 'src/model/duyuru';
import { Kullanici } from 'src/model/kullanici';
import { KullaniciGrup } from 'src/model/kullanici-grup';
import { RestService } from 'src/providers/rest.service';

@Component({
  selector: 'app-duyuru-ekle',
  templateUrl: './duyuru-ekle.component.html',
  styleUrls: ['./duyuru-ekle.component.css']
})
export class DuyuruEkleComponent implements OnInit {

  constructor(private _restService: RestService,
    private authService: AuthService,private _toastrService:ToastrService) { }

  user: Kullanici = null;
  duyuru: Duyuru = new Duyuru({});
  kullaniciGrupList: KullaniciGrup[];

  ngOnInit(): void {
    this.user = this.authService.getUser();
    this._restService.kullaniciGruplar().subscribe(res => {
      this.kullaniciGrupList = res;
    });

  }

  addDuyuru() {
    this.duyuru.isSilindi = false;
    this.duyuru.gonderenKullaniciId = this.user.id;
    this._restService.setDuyuru(this.duyuru).subscribe(res => {
      if(res.success){
        this._toastrService.success(res.message)
      } else {
        this._toastrService.error(res.message)
      }
    });
  }

}
